import { render } from "./UserAvatar.vue?vue&type=template&id=10d6feaa&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&lang=ts"
export * from "./UserAvatar.vue?vue&type=script&lang=ts"

import "./UserAvatar.vue?vue&type=style&index=0&id=10d6feaa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10d6feaa"

export default script